"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _useHash = _interopRequireDefault(require("./use-hash"));

var uuid = _interopRequireWildcard(require("uuid"));

var _react = require("react");

// this hash or clientsoureid is used to help create a managealbe sized property to store information in localstorage
// its possible we will just have the "authorization" as an identifier and that is a huge string
var useClientSourceId = function useClientSourceId(_ref) {
  var clientKey = _ref.clientKey,
      userId = _ref.userId,
      authorization = _ref.authorization,
      id = _ref.id,
      localStorage = _ref.localStorage;
  var clientSourceKey = (0, _useHash["default"])(authorization ? authorization : "".concat(clientKey, "/").concat(userId));
  return (0, _react.useMemo)(function () {
    if (!localStorage) {
      return;
    }

    var clientSourceIdLSKey = "clientSourceId/".concat(clientSourceKey);
    var localStorageClientSourceId = localStorage.getItem(clientSourceIdLSKey);

    if (localStorageClientSourceId) {
      return id ? "".concat(localStorageClientSourceId, "/").concat(id) : localStorageClientSourceId;
    }

    var newClientSourceId = uuid.v4();
    localStorage.setItem(clientSourceIdLSKey, newClientSourceId);
    return id ? "".concat(newClientSourceId, "/").concat(id) : newClientSourceId;
  }, [localStorage, clientSourceKey, id]);
};

var _default = useClientSourceId;
exports["default"] = _default;